
define('text!pages/help/help_page_video.html',[],function () { return '<video controls>\r\n    <source src="/files/intro.mp4" type="video/mp4">\r\n    <p>Din webbläsare stöder inte uppspelning av detta videoformat</p>\r\n</video>';});

